import React, { Component } from "react";
import Slider from "react-slick";
import Gallery1 from "../../assets/images/Gallery1.png";
import Gallery2 from "../../assets/images/Gallery2.png";
import Gallery3 from "../../assets/images/Gallery3.png";
import Gallery4 from "../../assets/images/Gallery4.png";

export default class Responsive extends Component {
  render() {
    var settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      initialSlide: 0,
      autoplay: true,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            initialSlide: 0,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    return (
      <div className="col-11 col-md-10 mx-auto px-md-5">
        <Slider {...settings}>
        <div>
          <img src={Gallery1} className="w-90 mx-auto px-md-2 px-3" alt="Huntsville Islamic Center Gallery Image 6"/>
        </div>
                <div>
          <img src={Gallery2} className="w-90 mx-auto px-md-2 px-3" alt="Huntsville Islamic Center Gallery Image 6"/>
        </div>
                <div>
          <img src={Gallery3} className="w-90 mx-auto px-md-2 px-3" alt="Huntsville Islamic Center Gallery Image 6"/>
        </div>
                        <div>
          <img src={Gallery4} className="w-90 mx-auto px-md-2 px-3" alt="Huntsville Islamic Center Gallery Image 6"/>
        </div>

        </Slider>
      </div>
    );
  }
}